/* eslint-disable */

import axios from 'axios';
import router from '../route';
import store from '../store/store';
import toast from './toast';

// Axios Interceptor for response handling
axios.interceptors.response.use(
  (response) => {
    // If the response is successful, simply return it
    return response;
  },
  (error) => {
    // Destructure error object for easier access
    const { response } = error;

    // If there's no response object, it might be a network error
    // Re-throw the error to be caught by the calling function
    if (!response) {
      toast.error('Network error or request timed out. Please check your internet connection.');
      return Promise.reject(error);
    }

    const { status, data } = response;

    // Handle different HTTP status codes
    switch (status) {
      case 400: // Bad Request
        if (data && data.code === 1000) {
          // Specific error codes for validation
          if (data.data && data.data.email) {
            toast.error(data.data.email[0], 'Email Error');
          } else if (data.data && data.data.password) {
            toast.error(data.data.password.msg, 'Password Error');
          } else if (data.data && data.data.profile && data.data.profile.mobile) {
            toast.error(data.data.profile.mobile[0], 'Mobile Error');
          } else {
            toast.error('Validation error occurred. Please check your input.');
          }
        } else if (data && data.non_field_errors) {
          toast.error(data.non_field_errors[0] || 'Bad Request');
        } else {
          toast.error(data.message || 'Bad Request occurred. Please try again.');
        }
        break;

      case 401: // Unauthorized
        toast.error('Your session expired. Please log in again.');
        store.dispatch('logoutManual');
        break;

      case 403: // Forbidden
        // Assuming code 8003 is a specific forbidden error related to session/permissions
        if (data && data.code === 8003) {
          toast.error(data.msg || 'Access forbidden. Please log in again.');
          store.dispatch('logoutManual');
        } else {
          toast.error(data.msg || 'You do not have permission to access this resource.');
        }
        break;

      case 415: // Unsupported Media Type
        toast.error('The media type of your request is not supported.');
        break;

      case 500: // Internal Server Error
        toast.error('An internal server error occurred. Please try again later.');
        break;

      case 502: // Bad Gateway
        toast.error('Bad Gateway. The server received an invalid response from an upstream server.');
        break;

      case 503: // Service Unavailable
        toast.error('Service unavailable. The server is currently unable to handle the request.');
        break;

      case 405: // Generic error message for unhandled status codes
        toast.error(data.message || `An unexpected error occurred (Status: ${status}).`);
        break;

      default:
        // Generic error message for unhandled status codes
        toast.error(data.msg || `An unexpected error occurred (Status: ${status}).`);
        break;
    }

    // Always reject the promise so that calling functions can catch and handle the error
    return Promise.reject(response);
  }
);